<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!infraestructureSelected) {
        <h1 class="title">Crear infraestructura</h1>
      }
    </div>
    <div class="title-color">
      @if (infraestructureSelected) {
        <h1 class="title">Editar infraestructura</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="infraestructureForm" (ngSubmit)="saveInfraestructure()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (infraestructureForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (infraestructureForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo</mat-label>
              <input
                type="text"
                matInput
                placeholder="Tipo"
                formControlName="type"
                maxlength="256"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (infraestructureForm.get('type')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <input
                type="text"
                matInput
                placeholder="Estado"
                formControlName="status"
                maxlength="256"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (infraestructureForm.get('status')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-checkbox formControlName="availability">Disponible</mat-checkbox>

            <mat-form-field appearance="outline">
              <mat-label>Máxima capacidad</mat-label>
              <input
                type="number"
                matInput
                placeholder="Máxima capacidad"
                formControlName="max_capacity"
              />
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="locationSelected"
                [initialValue]="getLocationValue()"
                placeholder="Seleccione una ubicación"
                label="Ubicación"
                noResults="Sin resultados"
                (onSelectOption)="onLocationSelected($event)"
              >
              </app-search-select>
            </div>

            <div class="search-select-container">
              <app-search-select
                [dataList]="addressSelected"
                [initialValue]="getAddressValue()"
                placeholder="Seleccione una dirección"
                label="Dirección"
                noResults="Sin resultados"
                (onSelectOption)="onAddressSelected($event)"
              >
              </app-search-select>
            </div>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!infraestructureForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
